export const getErrorMessage = (error: Error | any, defaultMessage: string = 'Something went wrong') => {
  const message = error.response?.data?.message;

  if (typeof message === 'string') {
    return message;
  }

  // NestJS's ValidationPipe returns `message` as a `string[]` (one entry per
  // failed class-validator rule). Join non-empty strings into a single
  // readable sentence; an empty array (or an array of falsy values) is not a
  // usable message, so fall through to the existing fallback chain below.
  if (Array.isArray(message)) {
    const joined = message.filter((m) => typeof m === 'string' && m.length > 0).join('. ');
    if (joined) {
      return joined;
    }
  }

  return error instanceof Error ? error.message : defaultMessage;
};
